<script setup>
defineProps(["item"]);
</script>

<template>
	<router-link :to="{ name: 'product', params: { slug: item.slug } }" :key="$route.fullPath">
		<div class="product-item flex flex-col items-center gap-4 lg:items-start lg:gap-8">
			<div class="relative w-fit rounded-big border border-border-default bg-bg p-3">
				<div class="product-item-bg w-fit cursor-pointer rounded-big bg-neutral-700 p-6 transition duration-300">
					<img :src="item.image" alt="photo" class="product-item-image h-[300px] w-[300px] rounded-big object-contain transition-transform duration-300" />
				</div>
				<div class="absolute left-[-1px] top-[15%] h-[70%] w-[1px] bg-bg" />
				<div class="absolute right-[-1px] top-[15%] h-[70%] w-[1px] bg-bg" />
			</div>
			<div class="flex max-w-[360px] flex-col items-center gap-3 uppercase text-default lg:items-start">
				<span v-if="item.type" class="label-small product-item-title w-fit rounded-small border border-default px-1 opacity-30 transition-opacity duration-300">
					{{ item.type }}
				</span>
				<p class="lg product-item-title text-center opacity-50 transition-opacity duration-300 lg:text-left">
					{{ item.title }}
				</p>
				<p v-if="item.available" class="lg flex gap-2">
					<span v-if="item.compare_at_price" class="line-through opacity-30">
						{{ item.compare_at_price }}
					</span>
					{{ item.price }}
				</p>
				<p v-else type="p-product-large" class="lg text-red-base">sold out</p>
			</div>
		</div>
	</router-link>
</template>

<style scoped>
.product-item:hover .product-item-bg {
	@apply scale-[1.03] bg-neutral-500;
}

.product-item:hover .product-item-image {
	@apply scale-[1.1];
}

.product-item:hover .product-item-title {
	@apply opacity-100;
}
</style>
